import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import Toast, { TYPE } from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vuelidate from "vuelidate";
import "vue2-datepicker/index.css";
import Datepicker from "vue2-datepicker";
Vue.use(Datepicker);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
// import "@/assets/globalcss/style.css";
import "@/assets/globalcss/newstyle.css";

import SearchBar from "./views/utils/SearchBar.vue";
import PrimaryButton from "./views/utils/PrimaryButton.vue";
import OutlineButton from "./views/utils/OutlineButton.vue";
const options = {
  // You can set your default options here
  toastDefaults: {
    [TYPE.ERROR]: {
      timeout: 5000,
      // icon: false,
      // closeButton: true,
      hideProgressBar: true,
    },
    [TYPE.SUCCESS]: {
      timeout: 5000,
      // icon: false,
      // closeButton: true,
      hideProgressBar: true,
    },
  },
};
Vue.config.productionTip = false;
Vue.use(Datetime);
Vue.component("datetime", Datetime);
Vue.use(Toast, options);

Vue.component("SearchBar", SearchBar);
Vue.component("PButton", PrimaryButton);
Vue.component("OButton", OutlineButton);

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation();
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value;
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false;
      exclude.forEach((refName) => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          let excludedEl = vnode.context.$refs[refName];
          excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;
          // Get the element using the reference name
          // See if this excluded element
          // is the same element the user just clicked on
          if (excludedEl) {
            // See if this excluded element
            // is the same element the user just clicked on
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]();
      }
    };
    // Register click/touchstart event listeners on the whole page
    document.addEventListener("click", handleOutsideClick);
  },
  unbind() {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener("click", handleOutsideClick);
  },
});
